const datas = {
    contenus: [
        {
            id: 1,
            image: ["Points-gris.svg", "Points-mobile.svg"],
            bandTitle: {
                title: "offre d'expertise",
                subTitle: "Une offre d'audit et de conseil pour reduire l'empreinte energetique des services numeriques",
                footerTitle: "conseil",
                image: "step-1.svg",
                style: {
                    color: "#40B59D"
                }
            },
            bandContents: [
                {
                    titles: [
                        {
                            title: "l'éco-conception",
                            style:
                                { color: "#40B59D", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "c'est quoi?",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-1.png",
                    paraph: {
                        content: "Nous accompagnons nos clients à éco-concevoir leurs services numériques et réduire leurs empreintes énergétiques :",
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px", marginBottom: "20px" }
                    },
                    listCheck: {
                        list: [
                            'Dès la phase <span class="methode-block-surligne">AMOA</span> et la rédaction des spécifications',
                            'En passant par l’<span class="methode-block-surligne">Architecture, l’UX/UI et le Code</span> de la solution',
                            'Et jusqu’au <span class="methode-block-surligne">Déploiement</span> du service'
                        ],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                },
                {
                    titles: [
                        {
                            title: "l'éco-conception",
                            style:
                                { color: "#40B59D", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "pourquoi?",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-2.png",
                    paraph: {
                        content: "",
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px" }
                    },
                    listCheck: {
                        list: [
                            'Réduire la <span class="methode-block-surligne">consommation d’énergie</span>',
                            'Réduire les <span class="methode-block-surligne">coûts à moyen et long terme</span>',
                            'Répondre aux <span class="methode-block-surligne">nouvelles demandes</span>',
                            'Augmenter la <span class="methode-block-surligne">satisfaction interne des employés</span>'
                        ],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                },
                {
                    titles: [
                        {
                            title: "l'éco-conception",
                            style:
                                { color: "#40B59D", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "comment?",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-3.png",
                    paraph: {
                        content: '<p></p>Groupe CREATIVE dispose d’un <span class="methode-block-surligne">référentiel</span> d’au moins <span class="methode-block-surligne">200 mesures et bonnes pratiques</span> en éco-conception, fruit de notre expertise ainsi que de projets de recherches au sein de CREATIVE Minds. </p> <p></p> <p>Groupe CREATIVE dispose d’une vraie expertise en <span class="methode-block-surligne">Green IT</span> et d’une véritable volonté pour construire un <span class="methode-block-surligne">numérique responsable</span>. Notre porteur d’offre qui est docteur en éco-conception logicielle & Green IT, ainsi que nos équipes, sont mobilisés pour appliquer les mesures d’éco-responsabilité en interne avant de les proposer à nos clients.</p> Afin de construire un numérique plus responsable.',
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px" }
                    },
                    listCheck: {
                        list: [],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                }
            ]
        },
        {
            id: 2,
            image: ["Points-gris-2.svg", "Points-mobile.svg"],
            bandTitle: {
                title: "offre de formation",
                subTitle: "Une formation adaptée aux profils techniques pour inculquer aux collaborateurs les principes d’éco-conception et la réduction de l’empreinte énergétique",
                footerTitle: "formation",
                image: "step-2.svg",
                style: {
                    color: "#FF686B"
                }
            },
            bandContents: [
                {
                    titles: [
                        {
                            title: "SENSIBILISER",
                            style:
                                { color: "#FF686B", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-4.png",
                    paraph: {
                        content: "",
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px", marginBottom: "20px" }
                    },
                    listCheck: {
                        list: [
                            'Sensibiliser les collaborateurs sur les problèmes de réchauffement climatique',
                            'Apprendre aux collaborateurs à faire du benchmarking de l’empreinte énergétique',
                            'Appliquer la réduction d’empreinte énergétique de services numériques à travers des mini-laboratoires'
                        ],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                },
                {
                    titles: [
                        {
                            title: "former",
                            style:
                                { color: "#FF686B", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-5.png",
                    paraph: {
                        content: "",
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px" }
                    },
                    listCheck: {
                        list: [
                            'Communiquer sur les bonnes pratiques et mesures pour éco-concevoir un service numérique.',
                            'Discuter les erreurs fréquentes des développeurs',
                            'Illustrer avec de vrais exemples issus de cas réels'
                        ],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                },
                {
                    titles: [
                        {
                            title: "concrétiser",
                            style:
                                { color: "#FF686B", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        },
                        {
                            title: "",
                            style: { color: "#201F1F", marginTop: "-20px", letterSpacing: "2px", fontSize: "35px", fontWeight: 900 }
                        }
                    ],
                    image: "Visuel-Step-6.png",
                    paraph: {
                        content: '',
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%", marginTop: "45px" }
                    },
                    listCheck: {
                        list: [
                            "Initier les collaborateurs à la mesure énergétique et aux outils de mesures",
                            "Apprendre aux collaborateurs à faire du benchmarking de l’empreinte énergétique",
                            "Appliquer la réduction d’empreinte énergétique de services numériques à travers des mini-laboratoires"
                        ],
                        style: { color: "#000000", letterSpacing: "2px", fontSize: "25px", fontWeight: 300, width: "80%" }
                    }
                }
            ]
        }
    ]
}
export default datas;